import { render } from "./SlidePanel.vue?vue&type=template&id=45411062"
import script from "./SlidePanel.vue?vue&type=script&lang=js"
export * from "./SlidePanel.vue?vue&type=script&lang=js"

import "./SlidePanel.vue?vue&type=style&index=0&id=45411062&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__